<template>
  <div class="media-images">
    <div :class="[ images.length === 4 ? 'is-grid' : 'is-row', 'tile', 'tile-images', 'is-ancestor']">
      <div v-for="image in images" :key="image.id" :class="['tile', imageTileClass]">
        <img :src="image.url" alt="" @click="modalImage = image; showModal = true">
      </div>
    </div>
    <b-modal v-model="showModal" :destroy-on-hide="false">
      <p class="image">
        <img :src="modalImage.url" alt="">
      </p>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'tweet-images',
  props: {
    images: {}
  },
  data() {
    return {
      modalImage: {},
      showModal: false
    }
  },
  computed: {
    imageTileClass() {
      switch (this.images.length) {
        case 1:
          return 'is-12'
        case 3:
          return 'is-4'
        default:
          return 'is-6'
      }
    }
  }

}
</script>
<style lang="scss" scoped>


.tile.is-ancestor {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
  border-radius: 0.5rem;
  max-height: 300px;
  overflow: hidden;


  img {
    width: 100%;
    max-height: 300px;
    object-fit: cover;
    cursor: pointer;
  }

  .tile {
    padding-right: 2px;
    padding-bottom: 2px;
  }

  &.is-row {
    .tile:first-child {
      img {
        border-top-left-radius: 0.5rem;
        border-bottom-left-radius: 0.5rem;
      }
    }

    .tile:last-child {
      img {
        border-top-right-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;
      }
    }
  }

  &.is-grid {
    flex-wrap: wrap;

    .tile {
      max-height: 150px;
    }

    .tile:first-child {
      img {
        border-top-left-radius: 0.5rem;
      }
    }

    .tile:nth-child(2) {
      img {
        border-top-right-radius: 0.5rem;
      }
    }

    .tile:nth-child(3) {
      img {
        border-bottom-left-radius: 0.5rem;
      }
    }

    .tile:last-child {
      img {
        border-bottom-right-radius: 0.5rem;
      }
    }

  }
}
</style>
